import request from "../../../infra/request";

export const downloadErrorReportFile = async (id) => {
  if (!id) {
    return { error: new Error("The file id can not be empty") };
  }
  try {
    const response = await request.get(`/admin/error-gp-reports/file/${id}`);
    return { data: response.data };
  } catch (error) {
    return {
      error: {
        message: error.message,
        code: error.response?.code || error.response?.statusText,
        status: error.response?.status,
      },
    };
  }
};
